import React from "react";
import { connect } from "react-redux";
import { SketchPicker } from "react-color";
import {
    Row,
    Col,
    Label,
    Input
} from "reactstrap";
import Select from 'react-select';
import EditorSlider from "../../../../components/editor/tools/EditorSlider";
import { AlignmentButtonGroup } from "../../../../components/editor/tools/AlignmentButtonGroup/AlignmentButtonGroup";
import { templateHelper } from "../../../template/helpers/templateHelper";
import { emailActions } from "../../../../../store/actions/cms/email/email.action";
import { setValueToNestedObject, deepClone } from "../../../../../helpers/objectHelper";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import ColorPickerFacade from "../../../../../components/UI/Buttons/ColorPickerFacade";
import { UseTemplateButton, SetStyleToAllOfItsType, SetToAuto } from "../../components/UseTemplateButton";
import ListExpansion from "../../../../../components/UI/ListExpansion/ListExpansion";
import { UrlMultiInput } from "../../../../components/editor/tools/UrlMultiInput/UrlMultiInput";
import { emptySpaceHandler } from "./EmptySpace.handler";



class EmptySpaceSettings extends React.Component {
    state = {
        spreadActiveSet: []
    }
    handleSoftUpdate = element => {
        const { dispatch } = this.props;
        element.content = emptySpaceHandler.elementEditor(element.style);
        dispatch(emailActions.updateEmailElement(element, null, true, this.props.inherit));
    }
    useTemplateStyle = (stylePath, templatePath) => {
        const { selectedElement, template } = this.props;
        let elementCopy = deepClone(selectedElement);
        let templateCopy = deepClone(template)

        const styleParts = stylePath.split(".");
        const templateParts = templatePath.split(".");

        let unit = templateHelper.getUnit(templateCopy, templateParts);
        let value = templateHelper.getValueWithoutUnit(templateCopy, templateParts);

        if (parseInt(value) && unit.length < 4) {
            value += unit;
        }

        elementCopy.style = setValueToNestedObject(
            styleParts,
            value,
            elementCopy.style
        );

        this.handleSoftUpdate(elementCopy);

        if (this.state.spreadActiveSet.includes(styleParts[styleParts.length - 1]) || this.state.spreadActiveSet.includes(styleParts[styleParts.length - 2] + styleParts[styleParts.length - 1])) {
            this.spreadStyle(elementCopy.type, styleParts, value)
        }

    }
    spreadStyle = (type, parts, value) => {
        const elementsCopy = Array.from(this.props.elements);
        if (elementsCopy.length === 0) return;
        const typeFamily = elementsCopy.filter(el => el.type === type);
        if (typeFamily.length === 0) return;
        typeFamily.map(tf => {
            let newEl = deepClone(tf);
            newEl.content = emptySpaceHandler.elementEditor(newEl.style);
            newEl.style = setValueToNestedObject(
                parts,
                value,
                newEl.style
            );
            this.handleSoftUpdate(newEl);
        });
    }
    handleChange = (e, val, path) => {
        const { selectedElement } = this.props;
        const names = path.split(".");
        let elementCopy = deepClone(selectedElement);
        let value = val;
        if (val && val.hex !== undefined) {
            value = templateHelper.parseRgbaToHex(val)
        }
        elementCopy.style = setValueToNestedObject(
            names,
            value,
            elementCopy.style
        );
        this.handleSoftUpdate(elementCopy);
        if (this.state.spreadActiveSet.includes(names[names.length - 1]) || this.state.spreadActiveSet.includes(names[names.length - 2] + names[names.length - 1])) {
            this.spreadStyle(elementCopy.type, names, value)
        }
    }
    spreadToggler = (name) => {
        let spreadActiveSet = Array.from(this.state.spreadActiveSet);
        if (spreadActiveSet.includes(name)) {
            spreadActiveSet = spreadActiveSet.filter(n => { return n !== name });
        }
        else {
            spreadActiveSet.push(name)
        }
        this.setState({ spreadActiveSet });
    }
    handleSpaceOnChange = (e, path, dir) => {
        const names = path.split(".");
        const elementCopy = deepClone(this.props.selectedElement);
        const spaceValue = elementCopy.style[names[0]][names[1]];
        let value = e.target.value;
        let splitted = spaceValue.toString().split(' ')
        let baseValue = '';
        if (splitted.length > 1) {
            splitted[dir] = value + 'px';
            splitted = splitted.join(' ')
            baseValue = splitted;
            elementCopy.style = setValueToNestedObject(
                names,
                splitted,
                elementCopy.style
            );
        }
        else {
            let newString = `${splitted[0]}px ${splitted[0]}px ${splitted[0]}px ${splitted[0]}px`;
            newString = newString.split(' ');
            newString[dir] = value + 'px';
            baseValue = newString;
            elementCopy.style = setValueToNestedObject(
                names,
                newString,
                elementCopy.style
            );
        }
        this.handleSoftUpdate(elementCopy);
        if (this.state.spreadActiveSet.includes(names[names.length - 1]) || this.state.spreadActiveSet.includes(names[names.length - 2] + names[names.length - 1])) {
            this.spreadStyle(elementCopy.type, names, baseValue)
        }
    }
    convertSpaceValue = (value, index) => {
        let splitted = value.toString().split(' ')
        if (splitted.length > 1) {
            return parseInt(splitted[index]);
        }
        else {
            return parseInt(splitted[0]);
        }
    }
    render() {
        const { selectedElement, template } = this.props;
        return (
            <React.Fragment>
                <ListExpansion
                    footer={false}
                    icon="fa fa-image"
                    description="Settings"
                    defaultExpanded={true}
                >
                    <Row>
                        <Col className="list-setting-item-title">
                            <Label>
                                <SystemLabel name="BackgroundColor" />
                            </Label>
                        </Col>
                        <Col className="list-setting-item-item">
                            <ColorPickerFacade
                                color={selectedElement.style.styleProps.backgroundColor}
                                path={"styleProps.backgroundColor"}
                                onChange={(color, e) =>
                                    this.handleChange(e, color, "styleProps.backgroundColor")
                                }
                            />
                        </Col>
                        <br />
                    </Row>
                    <Row>
                        <Col className="list-setting-item-title curved-panel-stack">
                            <UseTemplateButton
                                onClick={
                                    () => this.useTemplateStyle(
                                        "styleProps.backgroundColor",
                                        "main.backgroundColor"
                                    )}
                                active={(selectedElement.style.styleProps.backgroundColor === template.content.main.backgroundColor)}
                            />
                            <SetStyleToAllOfItsType
                                onClick={() => this.spreadToggler('backgroundColor')}
                                active={this.state.spreadActiveSet.includes('backgroundColor')}
                            />
                            <br />
                        </Col>
                    </Row>
                    <EditorSlider
                        value={selectedElement.style.styleProps.height !== undefined &&
                            selectedElement.style.styleProps.height !== "unset"
                            ? parseInt(selectedElement.style.styleProps.height)
                            : 0}
                        defaultValue={0}
                        unitChange={() => null}
                        onChange={this.handleChange}
                        units={["px"]}
                        activeUnit={'px'}
                        attachUnit={true}
                        steps={1}
                        max={1000}
                        min={1}
                        path={'styleProps.height'}
                        label="Height"
                    />
                    <Row>
                        <Col className="list-setting-item-title curved-panel-stack">
                            <SetStyleToAllOfItsType
                                onClick={() => this.spreadToggler('height')}
                                active={this.state.spreadActiveSet.includes('height')}
                            />
                            <br />
                        </Col>
                    </Row>

                </ListExpansion>
            </React.Fragment>
        );
    }
}
function mapStateToProps(state) {
    return {
        elements: state.email.elements,
        template: state.template.template,
        inherit: state.email.inherit,
        selectedElement: state.email.selectedElement
    };
}
export default connect(mapStateToProps)(EmptySpaceSettings);
